import { Route } from '@angular/router';
import { AuthUrlParts, maintenanceGuard, unauthenticatedGuard } from '@examdojo/auth';

export const authRoutes: Route[] = [
  {
    path: AuthUrlParts.Login,
    data: { animation: 'SignInPage' },
    canActivate: [maintenanceGuard, unauthenticatedGuard],
    loadComponent: () => import('./sign-in/sign-in.component').then((c) => c.SignInComponent),
  },
  {
    path: AuthUrlParts.Register,
    data: { animation: 'SignUpPage' },
    canActivate: [maintenanceGuard, unauthenticatedGuard],
    loadComponent: () => import('./sign-up/sign-up.component').then((c) => c.SignUpComponent),
  },
  {
    path: AuthUrlParts.Otp,
    data: { animation: 'OtpPage' },
    canActivate: [maintenanceGuard, unauthenticatedGuard],
    loadComponent: () => import('@examdojo/auth').then((c) => c.SignInOTPComponent),
  },
];
